import {
  filters,
  FILTER_TYPE,
  API_INFINITY_VALUE,
} from '../../../../../constants';
import { dots } from '../../../../../functions';
import type { CustomCompanyFilter } from './types';
import { toSignificant } from '@/utilities/formatting';

export const generateManagementFilters = (): CustomCompanyFilter[] => [
  {
    id: filters.insiderBuying,
    label: 'Insider Buying Ratio',
    type: FILTER_TYPE.RANGE,
    labels: {
      ...dots(100, { step: 10 }),
      0: '0%',
      50: '50%',
      100: '100%',
    },
    min: 0,
    max: 100,
    defaultValue: `["${filters.insiderBuying}", "between", 0, 100]`,
    rule: (range) => {
      if (range instanceof Array) {
        const [min, max] = range;
        return `["${filters.insiderBuying}", "between", ${min}, ${max}]`;
      }
      return '';
    },
    titleFormatter: ([_, __, min, max]) =>
      `is between ${min}% and ${max === API_INFINITY_VALUE ? '∞' : `${max}%`}
      (0% = all selling, 100% = all buying)`,
    //return value as float as expected by API
    valueResolver: (range) =>
      range.map((value) => toSignificant(value / 100, 2)),
  },
  {
    id: filters.ownershipProportionIndividualInsiders,
    label: 'Percentage of insider ownership',
    labels: {
      ...dots(60, { start: 0, step: 5 }),
      0: '0',
      20: '20%',
      40: '40%',
      60: '60%',
      80: '80%',
      100: '100%',
    },
    defaultValue: `["${filters.ownershipProportionIndividualInsiders}", "between", 0, 0.05]`,
    rule: (range) =>
      `["${filters.ownershipProportionIndividualInsiders}", "between", ${range[0]}, ${range[1]}]`,
    ruleToValue: ([_, __, ...range]) =>
      range.map(Number).map((value) => {
        return value * 100;
      }),
    min: 0,
    max: 100,
    type: FILTER_TYPE.RANGE,
    softMin: 0,
    softMax: 100,
    valueResolver: (range) => range.map((value) => value / 100),
    titleFormatter: ([_, __, ...range]) => {
      const [min, max] = range.map(Number);
      if (min === max) {
        return `is ${Math.floor(min * 100)}%`;
      } else {
        return `is between ${Math.floor(min * 100)}% and ${Math.floor(
          max * 100
        )}%`;
      }
    },
  },
];
